export const en = {
  titleImg: 'https://contents-virtual.eventxtra.com/uploads/reed902_staging/originals/2382053e-37c8-486a-ac21-0f144c8b2bd4.png',
};

export const ja = {
  titleImg: 'https://contents-virtual.eventxtra.com/uploads/reed902_staging/originals/bb80fc1f-ac40-40d8-9476-33864afbb24c.png',
};
